export const Api = (host, env) => {

   // const hosts = {local:'http://127.0.0.1:8000',serv:'http://ec2-3-13-248-4.us-east-2.compute.amazonaws.com'};
   const hosts = { local: 'http://127.0.0.1:8000', serv: 'http://ec2-3-16-89-5.us-east-2.compute.amazonaws.com', qa: 'https://api.getcogen.com' };

   // const envs = {dev:'dev',test:'test',uat:'uat', qa:'qa'};
   // console.log(hosts.serv);
   // const abc = `${hosts[host]}/api-${envs[env]}/public/api`;
   // console.log(abc);
   return `${hosts[host]}/api`;

   // const hosts = 'http://ec2-3-16-89-5.us-east-2.compute.amazonaws.com';
   // const envs = 'qa' //dev qa

   // return `${hosts}/api-${envs}/public/api`;
}